import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { Thumbnail } from '../Thumbnail/Thumbnail';
import { formatDateTime, formatDuration } from '../../utils';
import { Spacer } from '../Spacer/Spacer';

import type { FC } from 'react';
import type { SvpAsset } from '../../types';

import styles from './AssetsList.module.scss';

type Props = {
  assets: SvpAsset[];
  useVerticalThumbnails?: boolean;
  getLink: (asset: SvpAsset) => string;
};

const emptyList: SvpAsset[] = [];
Object.freeze(emptyList);
export const AssetsList: FC<Props> = ({
  assets,
  getLink,
  useVerticalThumbnails = false,
}) => {
  return (
    <div className={classNames(styles.assetsList)}>
      {assets.map((asset) => {
        const imageBase = useVerticalThumbnails
          ? (asset.additional?.metadata?.verticalPosterImage as
              string | undefined)
          : asset.images?.main;
        const imageUrl = imageBase ? `${imageBase}?t[]=x360q80` : undefined;

        return (
          <Link to={getLink(asset)} key={asset.id} className={styles.item}>
            <Thumbnail
              className={styles.thumbnail}
              aspectRatio={useVerticalThumbnails ? '2/3' : '16/9'}
              url={imageUrl}
            />
            <div className={styles.details}>
              <div className={styles.title}>{asset.title}</div>
              <span className={styles.subtitle}>
                {asset.series && (
                  <strong>
                    S{asset.series.seasonNumber}E{asset.series.episodeNumber}
                  </strong>
                )}{' '}
                {asset.category?.title}
              </span>
              <span className={styles.subtitle}>
                {asset.streamType === 'live'
                  ? 'Live stream'
                  : formatDuration(asset.duration ?? 0)}
              </span>
              <Spacer />
              <span className={styles.muted}>
                {formatDateTime((asset.created as number) * 1000)}
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};
